import script from "./WelfarePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WelfarePopup.vue?vue&type=script&setup=true&lang=js"

import "./WelfarePopup.vue?vue&type=style&index=0&id=accbd512&lang=scss"

const __exports__ = script;

export default __exports__